import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Tooltip } from 'antd';

import { vettingDocumentType } from '~constants/landlord';
import useStyles from './style';
import VettingDocumentModal from './modal';

import { isSupplyRole, isAdminRole, isRegionalSupplyHeadRole } from '~helpers/auth';

export const vettingDocumentOptions = [
  {
    linkType: vettingDocumentType.LANDLORD_LINK,
    name: 'cms.landlord.verification.landlord_links',
    type: 'landlordLink',
    emptyTextKey: 'cms.landlord.verification.landlord_links.empty_text',
  },
  {
    linkType: vettingDocumentType.REVIEW_SITE,
    name: 'cms.landlord.verification.review_sites',
    type: 'reviewSite',
    emptyTextKey: 'cms.landlord.verification.review_sites.empty_text',
  },
  {
    linkType: vettingDocumentType.LISTING_ON_OTHER_PLATFORM,
    name: 'cms.landlord.verification.listing_on_other_platforms',
    type: 'listingOnOtherPlatform',
    emptyTextKey: 'cms.landlord.verification.listing_on_other_platforms.empty_text',
  },
  {
    linkType: vettingDocumentType.SOCIAL_MEDIA,
    name: 'cms.landlord.verification.social_media',
    type: 'socialMedia',
    emptyTextKey: 'cms.landlord.verification.social_media.empty_text',
  },
];

const VerificationDocumentation = ({ landlord, getLandlord }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const modalRef = useRef(null);

  const dataSource = landlord.landlordLinks ?? {};

  const handleOpenModal = () => {
    modalRef.current?.handleOpenModal(dataSource);
  };

  return (
    <Row>
      <Col span={24}>
        <Card
          title={t('cms.landlord.verification.vetting_documentation')}
          bordered={false}
          className={classes.cardWrapper}
        >
          <For each="item" of={vettingDocumentOptions}>
            <Card
              bordered={false}
              title={t(item.name)}
              key={item.type}
              className={classes.tableCard}
              extra={
                <If condition={isSupplyRole() || isAdminRole() || isRegionalSupplyHeadRole()}>
                  <div onClick={handleOpenModal}>{t('cms.sepcial_offer.edit.btn')}</div>
                </If>
              }
            >
              <Choose>
                <When condition={dataSource[item.type]?.length > 0}>
                  <For each="childItem" index="idx" of={dataSource[item.type]}>
                    <Row className={classes.tableCardRow} key={`${item.type}-${idx}`}>
                      <Col>{idx + 1}</Col>
                      <Col>
                        <Tooltip title={childItem.link} placement={'top'}>
                          <a href={childItem.link} target={'_blank'} rel="noreferrer">
                            {childItem.link}
                          </a>
                        </Tooltip>
                      </Col>
                      <Col>
                        <Choose>
                          <When condition={childItem.note}>
                            <Tooltip title={childItem.note} placement={'top'}>
                              <span>{childItem.note}</span>
                            </Tooltip>
                          </When>
                          <Otherwise>
                            <span className={classes.emptyNote}>
                              {t('cms.landlord.verification.no_comment_yet')}
                            </span>
                          </Otherwise>
                        </Choose>
                      </Col>
                    </Row>
                  </For>
                </When>
                <Otherwise>
                  <span className={classes.emptyRowText}>{t(item['emptyTextKey'])}</span>
                </Otherwise>
              </Choose>
            </Card>
          </For>
        </Card>
      </Col>

      <Col span={24}>
        <VettingDocumentModal
          landlord={landlord}
          wrappedComponentRef={form => (modalRef.current = form)}
          getLandlord={getLandlord}
        />
      </Col>
    </Row>
  );
};

VerificationDocumentation.propTypes = {
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
};

export default VerificationDocumentation;
